import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';
import { saveAs } from 'file-saver';
import { ConfirmComponent } from "../../../shared/confirm/confirm.component";
import { DialogService } from "ng2-bootstrap-modal";

//Services
import { LimitFlowProposalService } from '../../../limit-flow-proposal/service/limit-flow-proposal/limit-flow-proposal.service';
import { AttachmentsenderService } from "../../service/attachmentsender.service";
import { DocumentType } from '../../../models/document-type';
import { Subscription } from "rxjs/Rx";

@Component({
    selector: 'app-attachmentsender',
    templateUrl: './attachmentsender.component.html',
    styleUrls: ['./attachmentsender.component.scss'],
    providers: [AttachmentsenderService]
})
export class AttachmentsenderComponent implements OnInit {

    @Input('proposalID') proposalID: string = "";
    @Input('accountClientID') accountClientID: string = "";
    @Input('proposalLayout') proposalLayout: string = "";
    @Input('proposalStatus') proposalStatus: string = "";
    @Input('isUserOwner') isUserOwner: boolean = false;
    
    proposalAttachments: any[] = [];
    AnexoArquivoByPropostaContaCliente: any = {}; //
    token: string = "";
    allowedFileSize: number;
    allowedFiles: string = "";
    docTypeAttach: string = "";
    descAttach: string = "";
    public complementAttach: string = "";
    public documentTypes: DocumentType;
    public proposalSubcription = new Subscription;
    public selectedFileName: string = "Selecionar Arquivo...";
    private permissoes = [];
   
    public orderby: string = "Descricao";
    public sort: string = "asc";
    public attachments: any[] = [];
    currentPage: number = 0;

    constructor(private flashMessagesService: FlashMessagesService, private dialogService: DialogService, private limitFlowProposalService: LimitFlowProposalService, private attachmentsenderservice: AttachmentsenderService) {
        this.token = localStorage.getItem('yara.token');
        this.documentTypes = new DocumentType();
    }

    ngOnInit() {

        this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
        
        this.getAttachmentByProposal();
        this.getFileSize();
        this.getFileType();

        this.proposalSubcription = this.limitFlowProposalService.proposalReload.subscribe(value => {
            console.log("Sou o component de anexo e alguem mudou o tipo de cliente");
            this.getAttachmentByProposal();
            this.getFileSize();
            this.getFileType();
        });
    }

    ngOnDestroy() {
        this.proposalSubcription.unsubscribe();
    }

    showRemoveAttachModal(id) {

        let disposable = this.dialogService.addDialog(ConfirmComponent, {
            title: 'Confirmação',
            message: 'Confirma a exclusão do anexo?',
            warning: "Essa ação não poderá ser revertida."
        },
            {
                backdropColor: 'rgba(0, 0, 0, 0.5)'
            }).subscribe((isConfirmed) => {
                //We get dialog result
                if (isConfirmed) {
                    this.inactivateAttachmentProposal(id);
                }
                else {
                    //Do nothing here for now
                }
            });
    }

    getAttachmentByProposal() {
        this.attachmentsenderservice.getAttachmentByProposal(this.proposalID).subscribe(result => {
            if (result.Success) {
                this.proposalAttachments = result.Result;
                this.getAttachmentList();
            } else {
                this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
            }
        }, error => {
            console.log(error);
        });
    }

    //Get Allowed file size for upload
    getFileSize() {
        this.attachmentsenderservice.getFileSize(this.token).subscribe(result => {
            if (result.Success) {
                this.allowedFileSize = result.Result.Valor;
            } else {
                this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
            }
        }, error => {
            console.log(error);
        });
    }

    //Get Allowed attachment file types
    getFileType() {
        this.attachmentsenderservice.getFileType(this.token).subscribe(result => {
            if (result.Success) {
                const files = result.Result[0].Valor.split(',');
                files.forEach(file => {
                    this.allowedFiles += '.' + file + ',';
                });
                console.log(this.allowedFiles);
            } else {
                this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
            }
        }, error => {
            console.log(error);
        });
    }

    //Get active attachments Types
    getAttachmentList() {

        var proposalLayout = $("#ProposalLayout").val() ? Number($("#ProposalLayout").val()) : 0;

        this.AnexoArquivoByPropostaContaCliente = {
            LayoutProposta: proposalLayout,
            PropostaId: this.proposalID,
            ContaClienteId: this.accountClientID
        }

        console.log("ObjPropostaLC:", this.AnexoArquivoByPropostaContaCliente);

        this.attachmentsenderservice.getAttachmentsByProposalLayout(this.AnexoArquivoByPropostaContaCliente).subscribe(result => {
            if (result.Success) {
                this.limitFlowProposalService.attachments = result.Result.filter(item => 
                    item.Ativo == true &&
                    !this.proposalAttachments.some(pa=> pa.AnexoID == item.ID));
            } else {
                this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
            }
        }, error => {
            console.log(error);
        });
    }

    setFile() {
		var input: any = document.getElementById("fileAttachProposal");
		var file = input.files[0];
		this.selectedFileName = file.name;
	}

    fileSelectedNew() {

        var input: any = document.getElementById("fileAttachProposal");

		if (!this.docTypeAttach) {
			this.flashMessagesService.show("Selecione uma Categoria", { cssClass: 'alert-danger', timeout: 6000 });
		} else if (!this.descAttach) {
			this.flashMessagesService.show("Preencha uma Descrição", { cssClass: 'alert-danger', timeout: 6000 });
		} else if (!input.files[0]) {
			this.flashMessagesService.show("Selecione um arquivo", { cssClass: 'alert-danger', timeout: 6000 });
		} else {
			var file = input.files[0];
			this.uploadAttachmentNew(file);
		}
    }

    uploadAttachmentNew(file) {
        if (file.size / (1024 * 1024) > this.allowedFileSize) {
            this.flashMessagesService.show("Erro: O arquivo é maior que o permitido: " + this.allowedFileSize + " Mb", { cssClass: 'alert-danger', timeout: 6000 });
            $("#fileAttachProposal").val("");
        } else {
            var formData = new FormData();

            formData.append('Arquivo', file);
            formData.append('PropostaLCID', this.proposalID);
            formData.append('AnexoID', '');
            formData.append('ContaClienteID', '');
            formData.append('CategoriaDocumento', this.docTypeAttach);
            formData.append('DescricaoAnexo', this.descAttach);
            formData.append('Complemento', this.complementAttach);

            this.attachmentsenderservice.saveAttachment(this.token, formData).subscribe(result => {
                if (result.Success) {
                    this.flashMessagesService.show("Anexo enviado com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
                    this.getAttachmentByProposal();
                    $("#fileAttachProposal").val("");
                    this.docTypeAttach = "";
                    this.descAttach = "";
                    this.complementAttach = "";
                    this.selectedFileName = "Selecionar Arquivo...";
                } else {
                    $("#fileAttachProposal").val("");
                    this.selectedFileName = "Selecionar Arquivo...";
                    this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
                }
            }, error => {
                console.log(error);
            });
        }
    }

    // When selected a file get the file and store on Arquivo attachmentList[i]
    fileSelected(id, i) {
        var input: any = document.getElementById(id);
        this.limitFlowProposalService.attachments[i].Arquivo = input.files[0];
        this.uploadAttachment(id, i);
    }

    //Fuction to upload the attachment, receive the index of attachmentList obj
    uploadAttachment(id, i) {
        if (this.limitFlowProposalService.attachments[i].Arquivo.size / (1024 * 1024) > this.allowedFileSize) {
            this.flashMessagesService.show("Erro: O arquivo é maior que o permitido: " + this.allowedFileSize + " Mb", { cssClass: 'alert-danger', timeout: 6000 });
            $("#" + id).val("");
        } else {
            var formData = new FormData();

            formData.append('Arquivo', this.limitFlowProposalService.attachments[i].Arquivo);
            formData.append('PropostaLCID', this.proposalID);
            formData.append('ContaClienteID', this.accountClientID);
            formData.append('AnexoID', this.limitFlowProposalService.attachments[i].ID);
            
            if (this.limitFlowProposalService.attachments[i].Complemento) {
                formData.append('Complemento', this.limitFlowProposalService.attachments[i].Complemento);
            }

            this.attachmentsenderservice.saveAttachment(this.token, formData).subscribe(result => {
                if (result.Success) {
                    this.flashMessagesService.show("Anexo enviado com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
                    
                    this.getAttachmentByProposal();
                } else {
                    $("#" + id).val("");
                    this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
                }
            }, error => {
                console.log(error);
            });
        }

    }

    downloadAttachmentProposal(index) {
        this.attachmentsenderservice.downloadAttachment(this.proposalAttachments[index].ID).subscribe(blob => {
            if (blob) {
                //Using File-saver.js
                saveAs(blob, this.proposalAttachments[index].NomeArquivo); 
            } else {
                this.flashMessagesService.show("Problema ao baixar o arquivo", { cssClass: 'alert-danger', timeout: 6000 });
            }
        }, error => {
            console.log(error);
        });
    }

    inactivateAttachmentProposal(id) {
        this.attachmentsenderservice.inactivateAttachment(id).subscribe(result => {
            if (result.Success) {
                this.flashMessagesService.show("Anexo removido com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
                this.getAttachmentByProposal();
            } else {
                this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
            }
        }, error => {
            console.log(error);
        });
    }

    searchAttachment() {

        this.orderby = "Descricao";
        this.sort = "asc";
        this.currentPage = 0;

        this.attachmentsenderservice.searchAttachmentByCategory(this.token, this.docTypeAttach, true, this.orderby, this.sort, 1).subscribe(result => {
            console.log(result);
            if (result.Success) {
                this.attachments = result.Result;

            } else {
                this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
            }
        }, error => {
            console.log(error);

        })
    }
    
}



// WEBPACK FOOTER //
// ./src/app/attachmentsender/component/attachmentsender/attachmentsender.component.ts